import '../../../common/dashboard/filters/single_filters/multiple_values_filter_view.js.coffee'
Namespace 'CustomerVisualMode.Filters.SingleFilters'

class CustomerVisualMode.Filters.SingleFilters.AssignedAdvisorFilterView extends
Common.Sessions.Filters.SingleFilters.MultipleValuesFilterView

  initialize: ({filter, selectedOptions, advisors, editable}) ->
    @filter = filter
    @advisors = advisors
    super({
      editable
      selectedOptions: selectedOptions
      values: @_possibleValues()
      placeholder: I18n.t('common.session.filters.assigned_advisor.modal.placeholder')
      title: I18n.t("common.session.filters.assigned_advisor.modal.#{if editable then '' else 'applied_'}title")
      subtitle: I18n.t("common.session.filters.assigned_advisor.modal.#{if editable then '' else 'applied_'}subtitle")
    })

  _selector: (values) ->
    new App.SelectWithIconsView
      options: values
      valueProperty: 'id'
      descriptionProperty: 'name'
      allOptionsClass: 'all-options-icon'
      selectedOptions: @selectedOptions
      placeholder: @placeholder
      editable: @editable
      multiple: true
      width: '100%'
      clearableInput: true

  _possibleValues: ->
    values = [
      {
        id: @filter.constructor.NOBODY_FILTER_TYPE
        name: I18n.t('customer.dashboard.conversations.details.assign.nobody')
        optionClass: 'unassigned-icon'
      },
      {
        id: @filter.constructor.ROBOT_FILTER_TYPE,
        name: 'Robot'
        optionClass: 'robot-icon'
      }
    ]
    values.concat(@_humanAdvisors())

  _humanAdvisors: ->
    @advisors.map(
      (advisor) => {
        id: advisor.get('user').id,
        name: @_displayName(advisor.get('user'))
      }
    )

  _displayName: (advisor) ->
    "#{advisor.last_name}, #{advisor.first_name} (#{advisor.email})"
